import { useUser } from '@clerk/react';
import { InboxEntry } from '@this+that/models';

export const useIsEntryOwner = (
  inboxEntry: Pick<InboxEntry, 'createdFor'> | null | undefined,
): boolean => {
  const { user } = useUser();
  return Boolean(user?.id) && user?.id === inboxEntry?.createdFor;
};
